class ScrollPosition {
    constructor() {
        this.scrollPosition = 0;

        this.getAnchors();
        this.getContainers();
    }

    init() {
        if (this.anchors.length === 0) {
            return;
        }

        requestAnimationFrame(this.calculateActiveAnchor.bind(this));
    }

    calculateActiveAnchor() {
        let newActiveAnchor;
        this.scrollPosition = window.pageYOffset + 100;

        this.clearActiveAnchor();

        for (let i = 0; i < this.containers.length; i++) {
            if (this.containers[i].getBoundingClientRect().top + window.pageYOffset < this.scrollPosition) {
                newActiveAnchor = i;
            }
        }

        if (newActiveAnchor >= 0) {
            this.setActiveAnchor(newActiveAnchor);
        }

        requestAnimationFrame(this.calculateActiveAnchor.bind(this));
    }

    setActiveAnchor(anchor) {
        this.anchors[anchor].parentElement.classList.add('is-active');
    }

    clearActiveAnchor() {
        let activeAnchor = document.querySelector('.list-inpage-nav .is-active');

        if (activeAnchor) {
            activeAnchor.classList.remove('is-active');
        }
    }

    getAnchors() {
        this.anchors = document.querySelectorAll('[data-scroll-anchor]');
    }

    getContainers() {
        this.containers = [];

        for (let i = 0; i < this.anchors.length; i++) {
            this.containers.push(document.querySelector(this.anchors[i].getAttribute('href')));
        }
    }
}

export default new ScrollPosition();
